import React, { useEffect, useRef, useState } from "react";

/** Numeric metric that smoothly animates from prev value to next. */
export const AnimatedMetric = ({ value, decimals = 0, className = "", prefix = "", suffix = "", testid }) => {
  const [display, setDisplay] = useState(value ?? 0);
  const raf = useRef(null);
  const from = useRef(value ?? 0);

  useEffect(() => {
    const start = performance.now();
    const fromV = from.current;
    const toV = Number(value) || 0;
    const duration = 650;
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(fromV + (toV - fromV) * eased);
      if (p < 1) raf.current = requestAnimationFrame(step);
      else from.current = toV;
    };
    cancelAnimationFrame(raf.current);
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [value]);

  return (
    <span className={className} data-testid={testid}>
      {prefix}{Number(display).toLocaleString(undefined, {
        minimumFractionDigits: decimals, maximumFractionDigits: decimals
      })}{suffix}
    </span>
  );
};

export default AnimatedMetric;
